import create from 'zustand'
import { persist } from 'zustand/middleware'
import { DependentListStore, Dependent, DependentNewData } from './types'

export const useDependentStore = create<DependentListStore>()(
  persist(
    (set, get) => {
      return {
        inactiveChildrenDependents: [],
        setInactiveChildrenDependents: (dependents: Dependent[]) => {
          set({ inactiveChildrenDependents: dependents })
        },
        selectedDependent: null,
        setSelectedDependent: (dependent: Dependent) => {
          set({ selectedDependent: dependent })
        },
        updateSelectedDependent: (selectedDependent: Partial<Dependent>) => {
          set({
            selectedDependent: {
              ...get().selectedDependent,
              ...selectedDependent,
            },
          })
        },
        adultDependents: [],
        setAdultDependents: (dependents: Dependent[]) => {
          set({ adultDependents: dependents })
        },
        dependentNewData: {
          cellphone: '',
          birthDate: '',
        },
        setDependentNewData: (newData: DependentNewData) => {
          set({ dependentNewData: newData })
        },
      }
    },
    {
      name: 'dependent',
      getStorage: () => sessionStorage,
    },
  ),
)
